import React, { useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Logo1 from '../assets/3ventures.png';
import Logo2 from '../assets/intercellar.png';
import Logo3 from '../assets/habs.png';
import Logo4 from '../assets/coming_soon.png';
import Img1 from '../assets/BackSlide6.jpg';

gsap.registerPlugin(ScrollTrigger);

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  padding-bottom: 10%;
  padding-top: 5%;
  position: relative;
  text-align: center;
  background-color: black;
  @media only screen and (min-device-width: 900px)and (max-device-width: 1024px) {
    min-height: auto;
    padding-top: 3rem;
  
 }
  @media (max-width: 900px) {
    min-height: auto;
    padding-top: 6rem;
  }
`;

const Title = styled.p`
  font-size: 8rem;
  font-family: 'MongoGrotesqueLight';
  margin: 0;
  color: #fff;
  display: flex;
  align-items: center;

  @media (max-width: 900px) {
    font-size: 5rem;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
   
  }
`;

const Subtitle = styled.p`
  font-size: 1rem;
  margin: 0;
  color: #ddd;

  @media (max-width: 900px) {
    font-size: 0.9rem;
  }
`;

const TitreContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-top: 2%;
  text-align: center;
  width: 80%;
  

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  width: 100%;
  margin-top: 3rem;

  @media (max-width: 900px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    width: 90%;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const CardImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  margin-bottom: 1rem;
`;

const CardSubtitle = styled.p`
  font-size: 1rem;
  color: #ddd;
  margin: 0;
`;
const SquaresWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex: 1;

  @media (max-width: 900px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    width: 100%;
    padding: 0 2rem;
  }
`;

const Square = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
  }
`;

const LogoIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ComingSoonOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-family: 'MongoGrotesqueLight', sans-serif;
  font-size: 2rem;
  color: #fff;
  z-index: 1;

  @media (max-width: 900px) {
    font-size: 1.2rem;
  }
`;

const Investissement: React.FC = () => {
  const logos = [Logo1, Logo2, Logo3, Logo4];
  const gridRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!gridRef.current) return;

    const cards = Array.from(gridRef.current.children) as HTMLElement[];

    gsap.set(cards, { opacity: 0, y: 30 });

    gsap.to(cards, {
      scrollTrigger: {
        trigger: gridRef.current,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power4.out',
      stagger: 0.2,
    });
  }, []);

  const items = [
    { img: Img1, subtitle: 'Titre 1' },
    { img: Img1, subtitle: 'Titre 2' },
    { img: Img1, subtitle: 'Titre 3' },
    { img: Img1, subtitle: 'Titre 4' },
  ];

  return (
    <PageContainer>
      <TitreContainer>
        <Title>NOS INVESTISSEMENTS</Title>
        <Subtitle>
          À travers Partouche Multiverse, le groupe investit dans des entreprises innovantes et les nouvelles technologies,
          <br />
          tout en explorant leur adaptation dans l'univers du gaming pour créer des expériences immersives et
          <br />
          résolument tournées vers l'avenir.
        </Subtitle>
      </TitreContainer>

      <SquaresWrapper>
    {logos.map((logo, i) => (
      <Square key={i}>
        <LogoIcon src={logo} alt={`Partenaire ${i + 1}`} />
        {i === 3 && (
          <ComingSoonOverlay>COMING SOON</ComingSoonOverlay>
        )}
      </Square>
    ))}
  </SquaresWrapper>
    </PageContainer>
  );
};

export default Investissement;